'use client'

import { TSimpleReviewCount } from '@/entities/room'
import { REVIEW_ILLUST_MAP } from '@/features/review-contract'
import { cn } from '@/shared/lib'
import { Illust } from '@/shared/ui'

import { SubHeading } from '../common'
import { ExpandableBox } from '../common/expandable'

const getBackgroundColor = (index: number) => {
  // 2열 그리드에서 B, P / P, B 와 같은 교차 패턴을 만들기 위한 로직입니다.
  const order = index + 1
  if (order % 4 === 0 || order % 4 === 1) {
    return 'bg-blue-50'
  }

  return 'bg-purple-50'
}

const MAX_HEIGHT = 152
export const MAX_DISPLAY_COUNT = 3

type Props = {
  simpleReviews: TSimpleReviewCount[]
  showAllButton?: boolean
}

export const SimpleReview = ({
  simpleReviews,
  showAllButton: showAllButtonProp = false,
}: Props) => {
  const moreThanMaxDisplayCount = simpleReviews.length > MAX_DISPLAY_COUNT

  const expandable = showAllButtonProp && moreThanMaxDisplayCount

  return (
    <div className="space-y-4 @max-md:space-y-3">
      <SubHeading>게스트가 선택한 장점</SubHeading>

      <ExpandableBox maxHeight={MAX_HEIGHT} expandable={expandable}>
        <ul className={cn('flex flex-wrap gap-x-6 gap-y-2 overflow-hidden')}>
          {simpleReviews.map((review, index) => (
            <li
              key={review.simpleReviewTemplateId}
              className={cn(
                'w-[343px] shrink-0 rounded-sm @max-md:w-full',
                getBackgroundColor(index),
                '@max-md:odd:bg-blue-50 @max-md:even:bg-purple-50',
              )}
            >
              <div
                className={cn(
                  'typo-label2 flex h-8 items-center justify-between py-1 pr-4 pl-2 text-black',
                )}
              >
                <div className="flex items-center gap-2.5">
                  <Illust
                    name={REVIEW_ILLUST_MAP[review.simpleReviewTemplateCode]}
                    size={24}
                  />
                  <span className="font-medium">{review.content}</span>
                </div>
                <span className="font-bold">{review.count}</span>
              </div>
            </li>
          ))}
        </ul>
      </ExpandableBox>
    </div>
  )
}
